import { IFooterTexts, ILink, INavLinks } from "component-library";

import { IFooter } from "translations/src/models/navigation";

export interface IFooterContent {
  navigationLinks: INavLinks;
  texts: IFooterTexts;
}

export const getFooterContent = (translation: IFooter): IFooterContent => ({
  navigationLinks: {
    footerLinks1: translation.footerItems.footerLinks1 as ILink[],
    footerLinks2: translation.footerItems.footerLinks2 as ILink[],
    footerLinks3: translation.footerItems.footerLinks3 as ILink[],
  },
  texts: {
    linkListsTitles: translation.linkListTitles,
    followCTA: translation.socialMedia.text,
    copyrightAddress: translation.copyrightAddress,
  },
});
